export default __webpack_public_path__ + "static/media/SR_1.42140d20.png";